import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./InputDropdown.scss";
import { gql, useLazyQuery } from "@apollo/client";

const Place_autocomplete = gql`
  query Place_autocomplete($searchText: String, $token: String) {
    Place_autocomplete(searchText: $searchText, Token: $token)
  }
`;
const Place_WithGooglePlaceId = gql`
  query Place_WithGooglePlaceId($token: String, $placeId: String, $name: String) {
    Place_WithGooglePlaceId(Token: $token, PlaceId: $placeId, name: $name)
  }
`;

interface dataType {
  name: string;
  place_id: string;
}
const InputToHandleGoogleAPI = ({ searchText, inputcontent, name, formkey, detectBlur, setBlur }) => {
  console.log("bbbggg");
  const dispatch = useDispatch();
  const [Token, setToken] = useState(Math.random() + "Headtler");
  const [selectedOption, setSelectedOption] = useState(-1);
  const [data, setData] = useState<dataType[]>([]);
  const [count, setCount] = useState(0);
  const [placeId, setPlaceId] = useState<dataType>();
  const MasterData = useSelector((store: any) => store?.FormDataReducer?.MasterData);

  const [getPlace_autocomplete] = useLazyQuery(Place_autocomplete, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [getPlace_WithGooglePlaceId] = useLazyQuery(Place_WithGooglePlaceId, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  useEffect(() => {
    if (searchText && detectBlur && (!MasterData[formkey] || !MasterData[formkey][name])) {
      inputcontent(data[0]?.name);
      setPlaceId(data[0]);
    }
    setBlur(false);
  }, [detectBlur, searchText]);

  useEffect(() => {
    const fetchData = async () => {
      getPlace_autocomplete({
        variables: {
          searchText: searchText,
          token: Token,
        },
      }).then((response: any) => {
        // let data = response.data.predictions?.map((el) => {
        //   return {
        //     name: el.structured_formatting.main_text,
        //     place_id: el.place_id,
        //   };
        // });
        setData(response.data.Place_autocomplete);
      });
    };
    if (searchText?.length > 2) {
      fetchData();
    }
  }, [searchText]);

  useEffect(() => {
    const gerData = async () => {
      getPlace_WithGooglePlaceId({
        variables: {
          placeId: placeId?.place_id,
          token: Token,
          name: placeId?.name,
        },
      }).then((response: any) => {
        let details = getComponent(response?.data?.Place_WithGooglePlaceId?.result);
        dispatch({
          type: "StoreMasterData",
          payload: { formkey, data: { [name]: details } },
        });
      });
    };
    if (placeId?.place_id) {
      gerData();
    }
  }, [placeId]);

  function getComponent(details: any) {
    let state = "";
    let pincode = "";
    let locality = "";
    let Level_2 = "";
    let Level_3 = "";
    let sublocality_level_1 = "";
    let sublocality_level_2 = "";
    let Country = "";
    let postal_code = "";
    details?.address_components?.forEach((component: any) => {
      if (component.types.includes("administrative_area_level_1")) {
        state = component.long_name;
      }
      if (component.types.includes("administrative_area_level_2")) {
        Level_2 = component.long_name;
      }
      if (component.types.includes("administrative_area_level_3")) {
        Level_3 = component.long_name;
      }
      if (component.types.includes("postal_code")) {
        pincode = component.long_name;
      }
      if (component.types.includes("locality")) {
        locality = component.long_name;
      }
      if (component.types.includes("sublocality_level_1")) {
        sublocality_level_1 = component.long_name;
      }
      if (component.types.includes("sublocality_level_2")) {
        sublocality_level_2 = component.long_name;
      }
      if (component.types.includes("country")) {
        Country = component.long_name;
      }
      if (component.types.includes("postal_code")) {
        postal_code = component.long_name;
      }
    });
    return {
      name: details.displayName,
      sublocalityLevel1: sublocality_level_1,
      sublocalityLevel2: sublocality_level_2,
      administrativeAreaLevel3: Level_3,
      administrativeAreaLevel2: Level_2,
      administrativeAreaLevel1: state,
      postal_code: postal_code,
      formattedAddress: details.formatted_address,
      locality: sublocality_level_1 ? `${sublocality_level_1},${locality}` : locality,
      locality2: locality,
      city: Level_3 ? Level_3 : Level_2,
      state: state,
      country: Country,
      placeId: placeId?.place_id,
      pincode: pincode,
      latitude: details.geometry.location.lat,
      longitude: details.geometry.location.lng,
      googleAPIResponseString: JSON.stringify(details),
    };
  }

  useEffect(() => {
    function handleKeyDown(event) {
      if (
        (event.keyCode === 9 && count === 0) ||
        (event.keyCode !== 38 && event.keyCode !== 40 && event.keyCode !== 8)
      ) {
        return;
      }
      if (event.keyCode === 38) {
        if (selectedOption > 0) {
          setSelectedOption((prevOption) => prevOption - 1);
          inputcontent(data[selectedOption - 1]?.name);
          setPlaceId(data[selectedOption - 1]);
          event.preventDefault();
        } else {
        }
      } else if (event.keyCode === 40) {
        if (data.length - 1 !== selectedOption) {
          setSelectedOption((prevOption) => prevOption + 1);
          if (typeof data === "object" && data[selectedOption + 1]?.name) {
            inputcontent(data[selectedOption + 1]?.name);
            setPlaceId(data[selectedOption + 1]);
          } else {
            inputcontent(data[selectedOption + 1]?.name);
            setPlaceId(data[selectedOption + 1]);
          }
          event.preventDefault();
        } else {
          setSelectedOption(0);
          inputcontent(data[0]?.name);
          setPlaceId(data[0]);
          event.preventDefault();
        }
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedOption, data]);

  return data?.length ? (
    <div className={`InputdropdownForQuery`}>
      <div className="table-header1">
        <div className="HeaderInDropDown">Name</div>
      </div>
      <div className="table-body">
        {data.map((e, i) => {
          const rowClass = i === selectedOption ? `row forHoverForQuery` : "row";
          return (
            <div
              key={i}
              className={rowClass}
              onClick={() => {
                inputcontent(e?.name);
                setPlaceId(e);
              }}
            >
              <div className="ColumnInDropDown">{e?.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    ""
  );
};

export default InputToHandleGoogleAPI;
